// components/StatsTicker.jsx
import React from 'react';

const StatsTicker = ({ stats }) => {
  if (!stats || stats.error) {
    return null; // Ha nincs adat vagy hiba van, ne rendereljen semmit
  }

  // Statisztikák szöveges formázása
  const tickerItems = [
    `Aktív felhasználók: ${stats.active_users.toLocaleString('hu-HU')}`,
    `Referensek: ${stats.referrals.toLocaleString('hu-HU')}`,
    `Összes hirdetés: ${stats.properties.total.toLocaleString('hu-HU')}`,
    `Eladó ingatlanok: ${stats.properties.for_sale.toLocaleString('hu-HU')}`,
    `Kiadó ingatlanok: ${stats.properties.for_rent.toLocaleString('hu-HU')}`,
    `Oldalmegtekintések: ${stats.page_views.toLocaleString('hu-HU')}`,
    `Városok száma: ${stats.unique_cities.toLocaleString('hu-HU')}`,
    // Top 3 ingatlan típus
    ...stats.properties.types
      .sort((a, b) => b.count - a.count)
      .slice(0, 5)
      .map((type) => `${type.type}: ${type.count.toLocaleString('hu-HU')}`),
  ];

  return (
    <div className='fixed top-0 left-0 w-full bg-secondary-500 bg-opacity-80 text-white text-sm py-2 overflow-hidden z-50'>
      <div className='ticker-wrapper'>
        <div className='ticker-content'>
          {tickerItems.map((item, index) => (
            <span key={index} className='mx-8'>
              {item}
            </span>
          ))}
          {/* Duplikált tartalom a folyamatos animációhoz */}
          {tickerItems.map((item, index) => (
            <span key={`dup-${index}`} className='mx-8'>
              {item}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatsTicker;

// Inline CSS az animációhoz
const styles = `
.ticker-wrapper {
  width: 100%;
  overflow: hidden;
}

.ticker-content {
  display: inline-block;
  white-space: nowrap;
  animation: ticker 60s linear infinite;
}

@keyframes ticker {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
`;

// Stílusok hozzáadása
const styleSheet = document.createElement('style');
styleSheet.type = 'text/css';
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);
